import type { AbstractServiceMarker, AnyServiceWithDeps } from './types';

export const isServiceWithDeps = (maybeService: unknown): maybeService is AnyServiceWithDeps =>
	typeof maybeService === 'function' && 'dependencies' in maybeService;

export const unimplementedAbstractService = <InputOrFuncSignature, Output = unknown>(
	serviceName: string,
) =>
	Object.assign(
		(_input: unknown) => {
			throw TypeError(`Unimplemented abstract service: ${serviceName}`);
		},
		{ abstract: true },
	) as ToImplementedServiceType<InputOrFuncSignature, Output> & AbstractServiceMarker;
// TODO(type safety): make abstract services fully type safe.
// instead of casting to a normal service type,
// produce an AbstractService type that our type pipeline will know
// that it needs an override

type ToImplementedServiceType<InputOrFuncSignature, OutputIfNotSignature> =
	InputOrFuncSignature extends (input: infer Input) => infer Output
		? InputOrFuncSignature
		: (input: InputOrFuncSignature) => OutputIfNotSignature;

export const toError = (maybeError: unknown) => {
	if (maybeError instanceof Error) {
		return maybeError;
	}
	return new TypeError('Service Error: ' + maybeError);
};
